// extracted by mini-css-extract-plugin
module.exports = {"Container":"TemplatesPicker_Container__2EBoG","TabButton":"TemplatesPicker_TabButton__1NDIv","Active":"TemplatesPicker_Active__2Wu3c"};